module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-next-back"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-d btn-lg",
    attrs: {
      "to": {
        name: this.prevRoute
      }
    }
  }, [_vm._v("Takaisin")]), _vm._v(" "), (_vm.type === 'finish') ? [_c('button', {
    staticClass: "btn btn-lg btn-midnight-blue pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = true
      }
    }
  }, [_vm._v("Lähetä")]), _vm._v(" "), _c('vk-modal', {
    attrs: {
      "show": _vm.show,
      "center": true
    },
    on: {
      "center": function($event) {},
      "clickOut": function($event) {
        _vm.show = false
      },
      "inactive": function($event) {
        _vm.show = false
      },
      "keyEsc": function($event) {
        _vm.show = false
      }
    }
  }, [_c('a', {
    staticClass: "uk-close",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', [_vm._v("Varmista tarjouspyynnön lähettäminen")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        Painamalla lähetä tarjouspyynnön saavat määrittämäsi vastaanottajat.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-d",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("Peruuta")]), _vm._v(" "), _c('a', {
    staticClass: "btn pull-right btn-lime-green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveQuote($event)
      }
    }
  }, [_vm._v("Lähetä")])])]), _vm._v(" "), _c('vk-modal', {
    attrs: {
      "show": _vm.showAfterSending,
      "center": true
    },
    on: {
      "center": function($event) {},
      "clickOut": function($event) {
        _vm.showAfterSending = false
      },
      "inactive": function($event) {
        _vm.showAfterSending = false
      },
      "keyEsc": function($event) {
        _vm.showAfterSending = false
      }
    }
  }, [_c('a', {
    staticClass: "uk-close",
    on: {
      "click": function($event) {
        _vm.showAfterSending = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', [_vm._v("Tarjouspyyntö lähetetty")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center bloc-md"
  }, [_c('span', {
    staticClass: "et-icon-envelope icon-xl icon-lime-green "
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(" Mahtavaa! ")]), _vm._v(" Toimittajat saavat ilmoituksen tarjouspyynnöstäsi sähköpostiinsa. Saat tiedon sähköpostiisi välittömästi\n        kun toimittaja lähettää sinulle tarjouksen.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-midnight-blue",
    attrs: {
      "to": {
        name: this.nextRoute,
        params: this.routeParams
      }
    }
  }, [_vm._v("Näytä omat tarjouspyynnöt")])], 1)])])] : [_c('router-link', {
    staticClass: "btn btn-lg btn-midnight-blue pull-right",
    attrs: {
      "to": {
        name: this.nextRoute,
        params: this.routeParams
      }
    }
  }, [_vm._v("Seuraava")])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7580e313"}!./src/app/components/nav-footer/nav-footer.html
// module id = 490
// module chunks = 1